






































  import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
  import TravelCriterionFilter from '../../components/filter/TravelCriterionFilter.vue'
  import PlaceholderCard from '../../components/cards/PlaceholderCard.vue'
  import onLocaleChangeMixin from '../../mixins/onLocaleChangeMixin'
  import {updateItems} from '../../lib'
  import {
    IAccommodation,
    ILocation,
    ITaste,
    ITravelCriteriaFull,
    IType,
    TravelCriteriaFull,
    Category,
    ITravelFilterData,
    ISeason,
    ITravelLimits,
    ICriterion,
    ITravelFilterIdsData,
    ITravelFilterIdsExtendedData,
    ICriterionData
  } from '../../entities'
  import {
    CriterionType,
    Filter,
    FilterNameType,
    IFilter,
    IFilterData,
    Range
  } from '../../components/lib/models'
import { TravelFormat } from '@/entities/abstract/travelFormat.model'

  @Component({
    components: {
      TravelCriterionFilter,
      PlaceholderCard
    }
  })
  export default class TravelCriteria extends Mixins(onLocaleChangeMixin) {

    @Prop({ default: false }) readonly headline?: boolean
    @Prop({ default: 'store' }) readonly output?: 'store' | 'event'
    @Prop({
      default: () => ([
        'price',
        'budget',
        'travel_format',
        'accommodation',
        'travel_type',
        'taste',
        'locations',
        'season',
        'category',
        'tourist',
        'duration_days'
      ])
    }) readonly use?: string[];

    protected initFetches = [
      this.fetchFilters
    ];

    protected reFetches = [
      this.updateTravelType,
      this.updateAccommodations,
      this.updateLocation,
      this.updateTaste,
      this.updateSeason
    ];

    protected fetching: boolean = false;

    get selectedFiltersCounter(): number {
      return this.filters?.reduce((counter: number, filter: IFilter) => (counter + (filter.selected ? 1 : 0)), 0);
    }

    private getFilterByLabel(label: string): IFilter | undefined {
      return this.filters.find((filter: IFilter) => filter.label === label);
    }

    private choiceFilters: ITravelCriteriaFull = new TravelCriteriaFull();

    private filters: IFilter[] = [];

    private fillFilters(): IFilter[] {
      return [
        {
          label: 'price',
          type: 'range' as CriterionType,
          max: this.travelLimits.price_max
        }, {
          label: 'budget',
          type: 'range' as CriterionType,
          max: this.travelLimits.budget_max
        },
        ...Object.keys(this.choiceFilters).map(field => ({
          label: field,
          type: 'check' as CriterionType,
          items: (this.choiceFilters as any)[field]?.map((f: any) => {
            return f.id ? f : {
              name: field === 'category' ? f : this.$t(field + '.' + f) as string,
              label: f
            };
          })
        })), {
          label: 'tourist',
          type: 'range' as CriterionType,
          max: this.travelLimits.tourist_max
        }, {
          label: 'duration_days',
          type: 'range' as CriterionType,
          max: this.travelLimits.duration_days_max
        }
      ]
        .filter((f: IFilterData) => this.use?.includes(f.label))
        .map((f: IFilterData) => {

          let values = this.getQuery(f.label);
          let range = [
            this.getQuery(f.label + '_min')[0],
            this.getQuery(f.label + '_max')[0]
          ].map((lim: string | undefined) => lim ? parseInt(lim) : lim) as Range;
          return {
            ...f,
            items: f.items?.map((item: ICriterionData<FilterNameType>) => {
              let name = item.name;
              let label = item.label;
              let params = values?.find(val=> val === label)
              return {
                ...item,
                value: name ? (values?.indexOf(name)!== -1|| !!params) : false
              };
            }) || undefined,
            range: range
          };
        })
        .map((filter: IFilterData) => new Filter(filter));
    }

    private getQuery(key: string): string[] {
      if (key) {
        let values = this.$route.query[key] as string;
        return values?.split(',') || [];
      } else {
        return [];
      }
    }

    private reset(): void {
      this.filters.forEach((filter: IFilter) => {
        filter.reset();
      });
    }

    private fetchFilters(): void {
      this.fetching = true;
      Promise.all([
        this.fetchTravelType(),
        this.fetchAccommodations(),
        this.fetchLocation(),
        this.fetchTaste(),
        this.fetchSeason(),
        this.fetchLimits()
      ])
        .then(() => {
          this.filters = this.fillFilters();
        })
        .catch(() => {})
        .finally(() => {
          this.fetching = false;
        });
    }

    private fetchCriterion<T>(action: Function, field: string): Promise<T[]> {
      return new Promise<T[]>((resolve, reject) => {
        action()
          .then((res: T[]) => {
            (this.choiceFilters as any)[field] = res
            resolve(res)
          })
          .catch((reason: any) => {
            reject(reason)
          });
      });
    }

    protected updateCriterion<T>(action: Function, field: string): void {
      let items = this.filters?.find((filter: IFilter) => filter.label === field)?.items;
      updateItems<ICriterion<FilterNameType>>(items, action);
    }

    // accommodation
    private fetchAccommodations(): Promise<IAccommodation[]> {
      return this.fetchCriterion<IAccommodation>(
        this.$storage.actions.fetchAccommodation,
        'accommodation'
      );
    }
    private updateAccommodations(): void {
      this.updateCriterion<IAccommodation>(
        this.$storage.actions.getAccommodationById,
        'accommodation'
      );
    }

    // type
    private fetchTravelType(): Promise<IType[]> {
      return this.fetchCriterion<IType>(
        this.$storage.actions.fetchTravelType,
        'travel_type'
      );
    }
    private updateTravelType(): void {
      this.updateCriterion<IType>(
        this.$storage.actions.getTravelTypeById,
        'travel_type'
      );
    }

    // taste
    private fetchTaste(): Promise<ITaste[]> {
      return this.fetchCriterion<ITaste>(
        this.$storage.actions.fetchTaste,
        'taste'
      );
    }
    private updateTaste(): void {
      this.updateCriterion<ITaste>(
        this.$storage.actions.getTasteById,
        'taste'
      );
    }

    // location
    private fetchLocation(): Promise<ILocation[]> {
      return this.fetchCriterion<ILocation>(
        this.$storage.actions.fetchLocation,
        'locations'
      );
    }
    private updateLocation(): void {
      this.updateCriterion<ILocation>(
        this.$storage.actions.getLocationById,
        'locations'
      );
    }

    // season
    private fetchSeason(): Promise<ISeason[]> {
      return this.fetchCriterion<ISeason>(
        this.$storage.actions.fetchSeason,
        'season'
      );
    }
    private updateSeason(): void {
      this.updateCriterion<ISeason>(
        this.$storage.actions.getSeasonById,
        'season'
      );
    }

    private travelLimits: ITravelLimits = {}

    private fetchLimits(): Promise<ITravelLimits> {
      return new Promise<ITravelLimits>((resolve, reject) => {
        this.$storage.actions.getTravelLimits()
          .then((res: ITravelLimits) => {
            this.travelLimits = res
            resolve(res)
          })
          .catch((reason: any) => {
            reject(reason)
          });
      });
    }

    get filterResult(): ITravelFilterIdsData {
      return {
        price_min: this.getFilterByLabel('price')?.range[0],
        price_max: this.getFilterByLabel('price')?.range[1],
        tourist_min: this.getFilterByLabel('tourist')?.range[0],
        tourist_max: this.getFilterByLabel('tourist')?.range[1],
        duration_days_min: this.getFilterByLabel('duration_days')?.range[0],
        duration_days_max: this.getFilterByLabel('duration_days')?.range[1],
        accommodation: this.getFilterByLabel('accommodation')?.selectedFilterIds,
        travel_type: this.getFilterByLabel('travel_type')?.selectedFilterIds,
        taste: this.getFilterByLabel('taste')?.selectedFilterIds,
        locations: this.getFilterByLabel('locations')?.selectedFilterIds,
        season: this.getFilterByLabel('season')?.selectedFilterIds,
        budget_min: this.getFilterByLabel('budget')?.range[0],
        budget_max: this.getFilterByLabel('budget')?.range[1]
      }
    }

    get filterResultExtended(): ITravelFilterIdsExtendedData {
      return {
        ...this.filterResult,
        category: this.getFilterByLabel('category')?.selectedFilterNames?.map((name: string) => name as Category),
        travel_format: this.getFilterByLabel('travel_format')?.selectedFilterNames?.map((travelName: string) => travelName as TravelFormat),
      }
    }

    get filterResultToRequest(): ITravelFilterData {
      return {
        price_min: this.filterResult.price_min,
        price_max: this.filterResult.price_max,
        tourist_min: this.filterResult.tourist_min,
        tourist_max: this.filterResult.tourist_max,
        duration_days_min: this.filterResult.duration_days_min,
        duration_days_max: this.filterResult.duration_days_max,
        accommodation: this.getFilterByLabel('accommodation')?.selectedFilterNames,
        travel_type: this.getFilterByLabel('travel_type')?.selectedFilterNames,
        taste: this.getFilterByLabel('taste')?.selectedFilterNames,
        locations: this.getFilterByLabel('locations')?.selectedFilterNames,
        season: this.getFilterByLabel('season')?.selectedFilterNames,
        budget_min: this.filterResult.budget_min,
        budget_max: this.filterResult.budget_max,

        category: this.filterResultExtended.category,
        travel_format: this.filterResultExtended.travel_format,
        // search: ''
      };
    }

    get storedFilters(): ITravelFilterData {
      return this.$store.state.filters;
    }

    @Watch('storedFilters', { deep: true })
    protected onStoredFiltersChanged(): void {
      if (this.storedFilters !== this.filterResultToRequest) {
        // re init filters if external component (e.g. footer) override it
        this.filters = this.fillFilters();
      }
    }

    @Watch('filterResultExtended', { deep: true })
    protected onFilterResultExtendedChanged(): void {
      if (this.output === 'store') {
        this.$storage.actions.setFilters(this.filterResultToRequest);
      } else {
        this.$emit('update', this.filterResultExtended);
      }
    }

  }
